import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const deleteState = async (id: string) => {
  const res = await apiManager.delete(`/admin/states/${id}/delete`);
  return res;
};

export const useDeleteState = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.STATES.DELETE_STATES(id));
      return res.data;
    },
  });